import { render, staticRenderFns } from "./MaterialsListV3.vue?vue&type=template&id=ca74977e&scoped=true&"
import script from "./MaterialsListV3.vue?vue&type=script&lang=ts&"
export * from "./MaterialsListV3.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialsListV3.vue?vue&type=style&index=0&id=ca74977e&lang=scss&scoped=true&"
import style1 from "./MaterialsListV3.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca74977e",
  null
  
)

export default component.exports